import React from 'react'
import * as styles from './staticImageContainer.module.scss'

export function StaticImageContainer({
	children,
	isOverflowVisible,
	positionObj,
	isAbsolute,
}) {
	const {
		top = 'auto',
		left = 'auto',
		right = 'auto',
		bottom = 'auto',
		...rest
	} = positionObj || {}
	const wrapperClassName = `${styles.image_wrapper}${
		isOverflowVisible ? ` ${styles.visible}` : ''
	}${isAbsolute ? ` ${styles.set_absolute}` : ''}`

	if (Object.keys(rest).length > 0) {
		throw new Error('Invalid props obj. Use only top, left, right or bottom')
	}

	const positionProps = {
		top: `${top}`,
		left: `${left}`,
		right: `${right}`,
		bottom: `${bottom}`,
	}

	return (
		<div className={wrapperClassName} style={positionProps}>
			{children}
		</div>
	)
}
